// One colour's supplier stock in a sentence (carpet supplier portals, 26 Oct 2026). No API client here, so a test renders it.
import {stockSentence, type StockColour} from '../lib/supplier-stock-words';
import type {useT} from '../lib/i18n';

type T = ReturnType<typeof useT>['t'];

export function SupplierStockLine({colour, t}: {colour: Pick<StockColour, 'available_lm' | 'rolls' | 'largest_roll_lm' | 'dye_lots' | 'next_production' | 'read_at'>; t: T}) {
  const s = stockSentence(colour);
  return <span className={colour.available_lm > 0 ? 'text-muted-foreground' : 'text-warning'}>{t(s.id, s.values)}</span>;
}
